import Box from "ds/components/Box";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import Icon from "ds/components/Icon";
import Typography from "ds/components/Typography";
import { External } from "components/icons/generated";
import IconEmphasized from "ds/components/IconEmphasized";

import { type ProductSwitcherProduct } from "./useProducts";

type ProductSwitcherItemProps = {
  product: ProductSwitcherProduct;
  onAction?: () => void;
};

const ProductSwitcherItem = ({ product, onAction }: ProductSwitcherItemProps) => {
  return (
    <DropdownMenuItem
      id={product.id}
      active={product.isCurrent}
      isDisabled={product.isDisabled}
      tooltip={product.tooltip}
      tooltipPlacement="right"
      tooltipWidthMode="maxWidthSm"
      onAction={onAction}
      href={product.href}
      analyticsTitle="Product switcher clicked"
      analyticsProps={{ id: product.id }}
    >
      <Box align="center" justify="between" gap="medium" fullWidth>
        <Box align="center" gap="medium">
          <IconEmphasized icon={product.icon} color={product.isCurrent ? "surface" : "gray"} />

          <Box direction="column" gap="small">
            <Typography tag="span" variant="p-body3">
              {product.title}
            </Typography>
            <Typography tag="span" variant="p-body4">
              {product.description}
            </Typography>
          </Box>
        </Box>

        {product.isExternal && <Icon src={External} noShrink />}
      </Box>
    </DropdownMenuItem>
  );
};

export default ProductSwitcherItem;
